// Migrado VERBATIM de context/DarkMode/index.js (THEME_CONFIGS.dark).
import { KR, sharedComponents } from "./shared";

export default {
  muiMode: "dark",
  scrollbarColor: KR.borderDark2,
  palette: {
    primary:    { main: KR.brand },
    secondary:  { main: KR.inkDarkSec },
    background: { default: KR.baseDark, paper: KR.surfaceDark },
    text:       { primary: KR.inkDark, secondary: KR.inkDarkSec },
    divider:    KR.borderDark,
    action: {
      hover:    "rgba(255,255,255,0.05)",
      selected: KR.brandSubtle,
    },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          backgroundColor: KR.surfaceDark2,
        },
        notchedOutline: { borderColor: KR.borderDark2 },
        input: { color: KR.inkDark, "&::placeholder": { color: KR.inkDarkMuted, opacity: 1 } },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: { color: KR.inkDark, "&::placeholder": { color: KR.inkDarkMuted, opacity: 1 } },
      },
    },
    MuiFormLabel: {
      styleOverrides: { root: { color: KR.inkDarkSec } },
    },
  },
  custom: {
    chat: { sentBg: "rgba(243, 112, 33, 0.2)", quotedSentBg: "rgba(243, 112, 33, 0.3)", quotedReceivedBg: "#1E1E1E", accent: "#F37021" },
    chartPalette: ["#F37021", "#4FC3F7", "#B39DDB", "#81C784", "#E57373", "#9575CD"],
    login: { bg: "#555A5F" },
  },
};
